import { WhyChooseOur } from '@/components'
import {
   ChallengingTasksIcon,
   DevelopmentSessionsIcon,
   DiverseRolesIcon,
   EndlessLearningIcon,
   GrowthAttitudeIcon,
   InclusiveCultureIcon,
   MentorSupportIcon,
   RewardsRecognitionsIcon,
   SoftSkillsBuildingIcon,
} from '@/svgs/discover-benzatine'
import React from 'react'

const featureCards = [
   {
      title: 'Endless Learning',
      description:
         'We promote ongoing learning by means of training programs, workshops, and upskilling tools so that our workforce remains competitive and ahead of industry trends in an ever-changing technological environment.',
      icon: <EndlessLearningIcon />,
   },
   {
      title: 'Challenging Tasks',
      description:
         'Development arises from challenges. Staff members are given difficult projects to work on that help improve problem-solving, flexibility, and leadership skills, which equip them to deal with real-world situations and extend their professional horizons.',
      icon: <ChallengingTasksIcon />,
   },
   {
      title: 'Mentor Support',
      description:
         'Seasoned mentors lead employees with career guidance, industry knowledge, and positive criticism. This collective learning process reinforces growth, boosts confidence, and shares valuable knowledge with more effective methods than traditional training',
      icon: <MentorSupportIcon />,
   },
   {
      title: 'Diverse Roles',
      description:
         'Learning about various roles enables employees to build cross-functional knowledge, find their strengths, and make contributions effectively. This versatility enables them to mold their careers while accumulating rich experience in multiple business functions.',
      icon: <DiverseRolesIcon />,
   },
   {
      title: 'Growth Attitude',
      description:
         'We promote a culture of ongoing improvement through inspiring employees to accept challenges, change, and acquire new skills to achieve professional and personal success in the long term in a rapidly changing work environment.',
      icon: <GrowthAttitudeIcon />,
   },
   {
      title: 'Inclusive Culture',
      description:
         'We believe diversity spurs innovation. We build an inclusive culture where all viewpoints are respected, providing equal opportunity and a feeling of belongingness that inspires employees to make a valuable contribution.',
      icon: <InclusiveCultureIcon />,
   },
   {
      title: 'Development Sessions',
      description:
         'Professional development is paramount. Our formal learning sessions, training, and knowledge-sharing forums endow employees with leadership competencies, industry know-how, and expertise to handle changing business demands.',
      icon: <DevelopmentSessionsIcon />,
   },
   {
      title: 'Rewards & Recognitions',
      description:
         'We acknowledge success through formal rewards and recognition programs, encouraging employees to aim for excellence, innovate, and keep making valuable contributions to the organization.',
      icon: <RewardsRecognitionsIcon />,
   },
   {
      title: 'Soft Skills Building',
      description: `Effective communication, leadership, and collaboration are essential. We develop employees' soft skills through workshops and practical exposure, enabling them to shine in professional and team settings.`,
      icon: <SoftSkillsBuildingIcon />,
   },
]

function EmployeeGrowth() {
   return (
      <div className="discover_employee_growth">
         <WhyChooseOur
            classCustom="our_culture_card"
            title={'Employee Growth Is Our Top Priority'}
            desc={
               'We firmly believe that when our employees grow, we grow. See how Benzatine Infotech nurtures growth and development every day.'
            }
            cardData={featureCards}
         />
      </div>
   )
}

export default EmployeeGrowth
